export const ALERT_MODAL_STATUS = {
  STABLE: 0,
  ERROR: 1,
  SUCCESS: 2,
};
